import * as React from 'react';

import './RegionSwitch.scss';
import USAFlag from './assets/usaflag';
import CANADAFlag from './assets/canadaflag';
import {
  goToCanadaSite,
  goToUSSite,
  goToCanadaSiteFr,
  canadaSiteFrUrl,
  canadaSiteUrl,
  USSiteUrl,
  getSiteLanguage,
  canadaSiteEn,
  canadaSiteEnUrl
} from 'src/utils/navigation';
import env from 'src/shared/env';

interface IRegionSwitchProps {
  signout: () => void;
  t?: any;
}

interface IRegionSwitchState {
  floatingIsOpen: boolean;
}

export default class RegionSwitch extends React.Component<
  IRegionSwitchProps,
  IRegionSwitchState
> {
  private flyMenuRef: any = null;

  constructor(props: any) {
    super(props);

    this.state = {
      floatingIsOpen: false
    };
  }

  /* 
    openMenu
   */
  private openMenu = () => {
    this.setState({ floatingIsOpen: true });
  };

  /* 
    closeMenu
   */
  private closeMenu = () => {
    this.setState({ floatingIsOpen: false });
  };

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      floatingIsOpen: false
    });
  };

  private changeCountrySite = (goTo: () => void) => {
    if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
      this.props.signout();
      goTo();
    } else {
      goTo();
    }
  };

  private changeCountrySiteCA = (goTo: () => void) => {
    if (env.REACT_APP_BASE_ENVIRONMENT === 'CA') {
      goTo();
    } else {
      this.props.signout();
      goTo();
    }
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
  }

  public render() {
    const { t } = this.props;
    const menuState = this.state.floatingIsOpen ? 'opened' : '';

    return (
      <div
        id="region-switcher-menu"
        onMouseOut={this.closeMenu}
        onMouseOver={this.openMenu}
      >
        <div id="region-switcher" onClick={this.handleMenuState}>
          <div className="region-switcher--flag">
            <img
              src={
                env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? CANADAFlag : USAFlag
              }
              alt="USA Flag"
            />
          </div>
          <div className="region-switcher--menu">
            <p className="roboto-semibold">
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? (getSiteLanguage() as string).toUpperCase()
                : 'EN'}
              {/* {env.REACT_APP_BASE_ENVIRONMENT_CA_LANG === } */}
            </p>
            <i className="rpds rpds-arrow-drop-down" />
          </div>
        </div>
        <div
          className={`region-switcher--fly-menu ${menuState}`}
          ref={ref => (this.flyMenuRef = ref)}
        >
          <p className="region-switcher-heading">
            {t('common.selectCountryAndLang')}
          </p>
          <a
            href={USSiteUrl()}
            className="menu-item "
            onClick={e => this.changeCountrySite(goToUSSite)}
          >
            <img
              className="rp-country-flag-align"
              src={USAFlag}
              alt="USA Flag"
            />
            {t('common.usEnglish')}
          </a>
          <a
            href={canadaSiteEnUrl()}
            className="menu-item "
            onClick={e => this.changeCountrySiteCA(canadaSiteEn)}
          >
            <img
              className="rp-country-flag-align"
              src={CANADAFlag}
              alt="Canada Flag"
            />
            {t('common.caEnglish')}
          </a>
          <a
            href={canadaSiteFrUrl()}
            className="menu-item "
            onClick={e => this.changeCountrySiteCA(goToCanadaSiteFr)}
          >
            <img
              className="rp-country-flag-align"
              src={CANADAFlag}
              alt="Canada Flag"
            />
            {t('common.caFr')}
          </a>
        </div>
      </div>
    );
  }
}
